import { Action } from 'redux-actions';
import { SET_ALL_EVERY_PORT_ACTION, SET_EVERY_PORT_ACTION, SetEveryPortServicePayload } from './actions';
import { NASProductFareFragment, NASProductFragment, NASSelectedProductFragment, NASStatus } from '@websky/graphql';

export interface EveryPortAdditionalServices {
	id: string;
	count: number;
}

export interface EveryPortSelectedService {
	product: NASProductFragment;
	additionalServices: EveryPortAdditionalServices[];
	travellerIds?: string[];
	fare: NASProductFareFragment;
	status?: NASStatus;
	orders: NASSelectedProductFragment['orders'];
}

export interface EveryPortSelectedServices {
	[category: string]: EveryPortSelectedService[];
}

export interface EveryPortServicesState {
	selectedServices: EveryPortSelectedServices;
}

const defaultState: EveryPortServicesState = {
	selectedServices: {}
};

export const everyPortServicesReducer = (
	state: EveryPortServicesState = defaultState,
	action: Action<SetEveryPortServicePayload | EveryPortSelectedServices>
): EveryPortServicesState => {
	if (action.type === SET_EVERY_PORT_ACTION) {
		const payload = (action as Action<SetEveryPortServicePayload>).payload;

		return {
			selectedServices: {
				...state.selectedServices,
				[payload.category]: [...payload.services]
			}
		};
	} else if (action.type === SET_ALL_EVERY_PORT_ACTION) {
		return {
			...state,
			selectedServices: (action as Action<EveryPortSelectedServices>).payload
		};
	}

	return state;
};
